
// libs
import moment from 'moment'
// types
import { FieldType } from 'types/graphql'

export const formatResolvedValue = (value: any, fieldType: FieldType | null | undefined): string => {
  if (value === null || value === undefined) {
    return ''
  }

  if (fieldType === FieldType.Switch) {
    return value ? 'Yes' : 'No'
  }

  if (fieldType === FieldType.Date) {
    return moment(value as string).format('DD/MM/YYYY HH:mm')
  }

  if (fieldType === FieldType.Tag) {
    return (value as any[]).map((item) => item.label ?? item.title).filter(Boolean).join(', ')
  }

  if (fieldType === FieldType.Address) {
    return (value as any)?.value?.address ?? ''
  }

  if (fieldType === FieldType.DocumentOrLink) {
    return (value as any)?.title ?? (value as any)?.url ?? ''
  }

  if (fieldType === FieldType.PickList || fieldType === FieldType.Lookup) {
    if (Array.isArray(value)) {
      return (value as any[])
        .map((item) => item.label)
        .filter(Boolean)
        .join(', ')
    }
    return (value as any)?.label ?? ''
  }

  return value
}
